import { getDeviceId } from '@24i/nxg-core-utils';
import { DeviceInfo } from '@24i/nxg-sdk-quantum';
import { Platform } from 'react-native';
import { getRuntimeConfig } from '@24i/nxg-sdk-smartott/src/Application/initApp';
import i18n from 'i18next';

export interface UserCodeReponse {
  code: string;
  url: string;
  urlComplete: string;
}
type ParsedURL = {
  protocol: string;
  host: string;
  hostname: string;
  port: string;
  pathname: string;
  search: string;
  hash: string;
};
export const getDeviceType = () => {
  const isWeb = DeviceInfo.getDeviceType().toString() === 'Web';
  const os = Platform.OS.toLowerCase();
  const isTv = Platform.isTV;
  if (isWeb) return 'web';
  if (isTv) return 'smarttv';
  return os;
};
export const getUserCode = async () => {
  try {
      const DeviceType = getDeviceType();
      const customService = getRuntimeConfig('apiService');
      const serviceId = customService.id;
      const appIdArray = customService.appId;
      const applicationId = appIdArray[DeviceType === 'smarttv' ? 'tvos' : DeviceType];
      const getLanguage = () => i18n.language;

      const headersLocal = {
          'Accept-Language': getLanguage(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Device-ID': await getDeviceId(),
          'X-Device-Type': getDeviceType(),
          ...(serviceId && { 'X-Service-ID': serviceId }),
          ...(applicationId && { 'X-Application-ID': applicationId }),
      };

      const res = await fetch(`https://backstage-api.com/user/code`, {
          method: 'GET',
          headers: headersLocal,
      });

      const data: UserCodeReponse = await res.json();

      return data;
  } catch (error) {
      console.error('Error in getUserCode:', error);
      return null;
  }
};

export const parseURL = (url: string): ParsedURL => {
  const urlObj = new URL(url);

  return {
      protocol: urlObj.protocol,
      host: urlObj.host,
      hostname: urlObj.hostname,
      port: urlObj.port,
      pathname: urlObj.pathname,
      search: urlObj.search,
      hash: urlObj.hash,
  };
}

export const redirectToSignup = async () => {
  const userCodeResponse = await getUserCode();
  if (userCodeResponse) {
      const hasTag = userCodeResponse.url.includes('#login');
      const hostUrl = hasTag ? userCodeResponse.url.slice(0, userCodeResponse.url.length - 6) : userCodeResponse.url;
      const authURLLocal = `${hostUrl}?code=${userCodeResponse.code}`;
      if (typeof window !== 'undefined') {
          const parsedLocalURL = parseURL(window.location.href.toString());
          const redirectUrl = `${parsedLocalURL.protocol}//${parsedLocalURL.host}/register?code=${userCodeResponse.code}`;
          const authURL = `${authURLLocal}&redirectUrl=${redirectUrl}#register`;
          window.location.href = authURL;
      }
  } else {
      console.error("User code response is null");
  }
};
